import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, LayerBottom, InputX, Select } from 'components'
import styles from './index.module.css'
import DetailTip from 'views/mydata/common/DetailTip'

const GrantModify = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)
	const [detailTip1, setDetailTip1] = useState(false)
	const [detailTip2, setDetailTip2] = useState(false)
	const [detailTip3, setDetailTip3] = useState(false)
	const [detailTip4, setDetailTip4] = useState(false)
	const [dataOpen, setDataOpen] = useState(0)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	const openDetail = () => {
		setDetailTip1(true)
	}

	const closeDetail = () => {
		setDetailTip1(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				{/* 기본정보 */}
				<div className="shadow">
					<div className={`${dataOpen === 0 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(0)}>
						<h3>기본정보</h3>
						<i className="icon icon_accordion_arrow" />
					</div>
					<div className="accordion-content padding pt_0">
						<p className={styles["m-title"]}>본인정보</p>
						<div className={`${styles["detail-box"]} mt_15 mb_0`}>
							<ul className="list-item" style={{ fontSize: "1.4rem" }}>
								<li>
									<span>성별</span>
									<span>여자</span>
								</li>
								<li>
									<span>나이</span>
									<span>만24세</span>
								</li>
							</ul>
						</div>
					</div>
				</div>

				{/* 가족정보 */}
				<div className="shadow">
					<div className={`${dataOpen === 1 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(1)}>
						<h3>가족정보</h3>
						<i className="icon icon_accordion_arrow" />
					</div>
					<div className="accordion-content padding pt_0">
						<p className={styles["m-title"]}>거주지</p>
						<div className={`${styles["select-area"]} mt_10`} onClick={openLayer}>
							<span style={{ color: "#ddd" }}>지역을 선택하세요.</span>
							<i className="icon" />
						</div>

						<p className={`${styles["m-title"]} mt_40`}>동거가족수</p>
						<Select className="mt_10" title="동거가족수" placeholder="동거가족수를 선택하세요." selected={1} data={[
							{ key: "1인 가구", value: 0 },
							{ key: "2인 가구", value: 1 },
							{ key: "3인 가구", value: 2 },
							{ key: "4인 가구", value: 3 },
							{ key: "5인 가구", value: 4 },
							{ key: "6인 이상 가구", value: 5 },
						]} onSelect={(key, value) => {
							console.log(key, value)
						}}>
						</Select>

						<p className={`${styles["m-title"]} mt_40`}>배우자유무</p>
						<div className="flex-align_center mt_15">
							<div className="chk flex--item_1">
								<input type="radio" id="spouse1" name="spouse" />
								<label htmlFor="spouse1">
									<span>있음</span>
								</label>
							</div>
							<div className="chk flex--item_1">
								<input type="radio" id="spouse2" name="spouse" />
								<label htmlFor="spouse2">
									<span>없음</span>
								</label>
							</div>
						</div>

						<p className={`${styles["m-title"]} mt_40`}>자녀유무</p>
						<ul className="opt-menu mt_10">
							<li className="active">미취학 아동</li>
							<li>초등학생</li>
							<li>중학생</li>
							<li>고등학생</li>
						</ul>

						<p className={`${styles["m-title"]} mt_40`}>어린이집이용여부</p>
						<div className="flex-align_center mt_15">
							<div className="chk flex--item_1">
								<input type="radio" id="careCenter1" name="careCenter" />
								<label htmlFor="careCenter1">
									<span>이용</span>
								</label>
							</div>
							<div className="chk flex--item_1">
								<input type="radio" id="careCenter2" name="careCenter" />
								<label htmlFor="careCenter2">
									<span>이용하지 않음</span>
								</label>
							</div>
						</div>
					</div>
				</div>

				{/* 소득정보 */}
				<div className="shadow">
					<div className={`${dataOpen === 2 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(2)}>
						<h3>소득정보</h3>
						<i className="icon icon_accordion_arrow" />
					</div>
					<div className="accordion-content padding pt_0">
						<p className={styles["m-title"]}>본인 월소득</p>
						<InputX type="text" id="" placeholder="0 만원" className="mt_10" />

						<p className={`${styles["m-title"]} mt_40`}>가구 월소득(본인소득 제외)</p>
						<InputX type="text" id="" placeholder="0 만원" className="mt_10" />
						<div className={`${styles["detail-box"]} mt_20`}>
							중위소득 <strong>50%</strong>(저소득층)입니다.
						</div>

						<p className={`${styles["m-title"]} mt_40`}>국민기초생활수급여부</p>
						<div className="flex-align_center mt_15">
							<div className="chk flex--item_1">
								<input type="radio" id="basicLife1" name="basicLife" />
								<label htmlFor="basicLife1">
									<span>수급</span>
								</label>
							</div>
							<div className="chk flex--item_1">
								<input type="radio" id="basicLife2" name="basicLife" />
								<label htmlFor="basicLife2">
									<span>미수급</span>
								</label>
							</div>
						</div>

						<p className={`${styles["m-title"]} mt_40`}>재직여부</p>
						<div className="flex-align_center mt_15">
							<div className="chk flex--item_1">
								<input type="radio" id="status1" name="status" />
								<label htmlFor="status1">
									<span>재직중</span>
								</label>
							</div>
							<div className="chk flex--item_1">
								<input type="radio" id="status2" name="status" />
								<label htmlFor="status2">
									<span>재직중 아님</span>
								</label>
							</div>
						</div>
					</div>
				</div>

				{/* 특성정보 */}
				<div>
					<div className={`${dataOpen === 3 ? "active" : ""} accordion-title flex-justify_between align_center padding`} onClick={() => setDataOpen(3)}>
						<h3>특성정보</h3>
						<i className="icon icon_accordion_arrow" />
					</div>
					<div className="accordion-content padding pt_0">
						<p className={styles["m-title"]}>임신/출산</p>
						<ul className="opt-menu mt_10">
							<li className="active">예비부모난임</li>
							<li>임산부</li>
							<li>출산(예정)</li>
							<li>고위험임신질환</li>
						</ul>

						<p className={`${styles["m-title"]} flex-align_center mt_40`}>
							장애인 <i className="icon icon_question ml_5" onClick={openDetail} />
						</p>
						<ul className="opt-menu mt_10">
							<li className="active">지체</li>
							<li className="disabled">시각</li>
							<li>청각</li>
							<li>언어</li>
							<li>지적</li>
							<li className="disabled">뇌병변</li>
							<li>자폐성</li>
							<li>정신</li>
							<li>신장</li>
							<li>장루</li>
							<li>심장</li>
							<li>호흡기</li>
							<li>중증장애</li>
						</ul>

						<p className={`${styles["m-title"]} flex-align_center mt_40`}>
							환자 <i className="icon icon_question ml_5" onClick={() => setDetailTip2(true)} />
						</p>
						<ul className="opt-menu mt_10">
							<li className="active">암</li>
							<li>감염병</li>
							<li>노인성질환</li>
							<li>HIV/AIDS(에이즈)</li>
							<li>결핵</li>
							<li>희귀난치성질환</li>
							<li>석면질환</li>
							{/* <li>기타질환</li> */}
							<li>코로나19</li>
							<li>수술/치료</li>
							<li>알레르기성질환</li>
							<li>한센인</li>
							<li>건강위험군</li>
							{/* <li>질병/부상질환</li> */}
							{/* <li>중증/난치/희귀질환</li> */}
							{/* <li>요양/치매환자</li> */}
						</ul>

						<p className={`${styles["m-title"]} flex-align_center mt_40`}>
							가족구성 <i className="icon icon_question ml_5" onClick={() => setDetailTip3(true)} />
						</p>
						<ul className="opt-menu mt_10">
							<li className="active">한부모가족</li>
							<li>독거노인</li>
							<li>다자녀가정</li>
							<li>다문화가정</li>
							<li>조손가정</li>
							<li>확대가족</li>
							<li>새터민가정</li>
							<li>입양∙위탁 가정</li>
						</ul>

						<p className={`${styles["m-title"]} mt_40`}>직업특성</p>
						<ul className="opt-menu mt_10">
							<li className="active">보육시설종사자</li>
							<li>복지시설종사자</li>
							<li>농수산업종사자</li>
							<li>공무원</li>
							<li>대학생</li>
						</ul>

						<p className={`${styles["m-title"]} mt_40`}>추가특성</p>
						<ul className="opt-menu mt_10">
							<li className="active">보훈대상자</li>
							<li>무주택</li>
							<li>이재민</li>
							<li>위기상황</li>
							<li>시설입소</li>
							<li>제대군인</li>
						</ul>
					</div>
				</div>
			</div>

			<div className="flex-shrink_0 padding btn-group">
				<Button className="btn btn--big btn--gray">초기화</Button>
				<Button className="btn btn--big ml_10">적용</Button>
			</div>


			<SelectLayer show={showLayer} closeLayer={closeLayer} />
			{/* 장애인 */}
			<DetailTip title="장애인" show={detailTip1} closeLayer={closeDetail} content="세부장애에 해당하지 않는 경우 해당사항 없는 장애를 선택해주세요." />
			{/* 환자 */}
			<DetailTip title="환자" show={detailTip2} closeLayer={() => setDetailTip2(false)} content="세부환자에 해당하지 않는 경우 해당사항 없는 환자를 선택해주세요." />
			{/* 가족구성 */}
			<DetailTip title="가족구성" show={detailTip3} closeLayer={() => setDetailTip3(false)} content="확대가족이란 부부,자녀 이외에 조부모등이 함께 사는 가족을 말해요." />
		</div>
	)
}

const SelectLayer = ({ show, closeLayer }) => {

	const [menuOpen, setMenuOpen] = useState(0)

	return (
		<LayerBottom title="지역 선택" show={show} closeLayer={closeLayer} closeButton={false} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			<ul className={`${styles["area-list"]} accordion-list`}>
				<li className={menuOpen === 0 ? "active" : ""} onClick={() => setMenuOpen(0)}>
					<div className="flex-justify_between align_center">
						<p className="bold">서울</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">강남구</li>
							<li>강동구</li>
							<li>강부구</li>
							<li>강서구</li>
							<li>관악구</li>
							<li>광진구</li>
							<li>구로구</li>
							<li>금천구</li>
							<li>노원구</li>
							<li>도봉구</li>
							<li>동대문구</li>
							<li>동작구</li>
							<li>마포구</li>
							<li>서대문구</li>
							<li>서초구</li>
							<li>성동구</li>
							<li>성북구</li>
							<li>송파구</li>
							<li>양천구</li>
							<li>영등포구</li>
							<li>용산구</li>
							<li>은평구</li>
							<li>종로구</li>
							<li>중구</li>
							<li>중랑구</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 1 ? "active" : ""} onClick={() => setMenuOpen(1)}>
					<div className="flex-justify_between align_center">
						<p className="bold">인천</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">중구</li>
							<li>동구</li>
							<li>미추홀구</li>
							<li>연수구</li>
						</ul>
					</div>
				</li>
				<li className={menuOpen === 2 ? "active" : ""} onClick={() => setMenuOpen(2)}>
					<div className="flex-justify_between align_center">
						<p className="bold">대전</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="menu-open mt_20">
						<ul className="menu-select">
							<li className="on">대덕구</li>
							<li>서구</li>
						</ul>
					</div>
				</li>
			</ul>
		</LayerBottom>
	)
}

export default GrantModify
